import create from 'zustand';

export type Item = {
  id: string;
  transactionType: string;
  currency: string;
  inrAmount: number;
  forexAmount: number;
  exchangeRate: number;
  exchangeTime: string;
};

export type TransactionDetails = {
  transactionType: string;
  currency: string;
  exchangeRate: number;
  totalPrice: number;
  purchaseAmount: number;
  serviceCharge: number;
  gst: number;
};

export type UserDetails = {
  userName: string;
  userEmail: string;
  userPhone: string;
  userCity: string;
  userState: string;
};

export type Store = {
  items: Item[];
  transactionDetails: TransactionDetails;
  setTransactionDetails: (details: Partial<TransactionDetails>) => void;
  addItem: (item: Item) => void;
  deleteItem: (id: string) => void;
  editItem: (id: string, item: Item) => void;
  userDetails: UserDetails;
  setUserDetails: (details: Partial<UserDetails>) => void;
  resetStore: () => void;
};

const initialState = {
  items: [],
  transactionDetails: {
    transactionType: '',
    currency: '',
    exchangeRate: 87.6,
    totalPrice: 0,
    purchaseAmount: 0,
    serviceCharge: 0,
    gst: 0,
  },
  userDetails: {
    userName: '',
    userEmail: '',
    userPhone: '',
    userCity: '',
    userState: '',
  },
};

export const useItemsStore = create<Store>((set) => ({
  ...initialState,
  addItem: (item) =>
    set((state) => ({ ...state, items: [...state.items, item] })),
  deleteItem: (id) =>
    set((state) => ({
      ...state,
      items: state.items.filter((item) => item.id !== id),
    })),
  editItem: (id, newItem) =>
    set((state) => ({
      ...state,
      items: state.items.map((item) => (item.id === id ? newItem : item)),
    })),
  setTransactionDetails: (newDetails) =>
    set((state) => ({
      ...state,
      transactionDetails: {
        ...state.transactionDetails,
        ...newDetails,
      },
    })),
  setUserDetails: (newDetails) =>
    set((state) => ({
      ...state,
      userDetails: {
        ...state.userDetails,
        ...newDetails,
      },
    })),
  resetStore: () => set(initialState),
}));
